import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { isRecent } from '../utils/catalog';
import { getAppMarketing } from '../utils/marketing';

const { FiArrowRight, FiStar } = FiIcons;

const statusLabels = {
  live: 'Live',
  beta: 'Beta',
  'coming-soon': 'Coming soon'
};

function Highlight({ text, query }) {
  if (!query) return text;
  const index = text.toLowerCase().indexOf(query.toLowerCase());
  if (index < 0) return text;

  return (
    <>
      {text.slice(0, index)}
      <mark>{text.slice(index, index + query.length)}</mark>
      {text.slice(index + query.length)}
    </>
  );
}

function AppCard({ app, query, onOpen }) {
  const marketing = getAppMarketing(app);
  const badges = [
    app.featured && ['featured', 'Featured'],
    isRecent(app.createdAt, 30) && ['new', 'New'],
    isRecent(app.updatedAt, 14) && ['updated', 'Updated']
  ].filter(Boolean).slice(0, 2);

  return (
    <button
      className={`app-card marketing-card ${app.status === 'coming-soon' ? 'coming-soon' : ''}`}
      type="button"
      onClick={() => onOpen(app)}
      aria-label={`View details for ${app.name}`}
    >
      <div className="app-preview">
        <img src={app.image || '/demo-app-preview.svg'} alt={`${app.name} preview`} />
        <span className="preview-category">{app.category}</span>
      </div>

      <div className="card-top marketing-card-top">
        <div className="badges">
          {badges.map(([type, label]) => (
            <span className={`badge ${type}`} key={type}>
              {type === 'featured' && <SafeIcon icon={FiStar} />}
              {label}
            </span>
          ))}
        </div>
      </div>

      <div className="card-copy">
        <h2><Highlight text={app.name} query={query} /></h2>
        <p><Highlight text={app.tagline} query={query} /></p>
      </div>

      <div className="problem-preview">
        <strong>Try it for</strong>
        <p>{marketing.useCases.slice(0, 2).join(' · ')}</p>
      </div>

      <div className="card-footer">
        <div>
          <span className={`status-dot ${app.status}`} />
          <span className="mono">{statusLabels[app.status]}</span>
        </div>
        <div className="view-details">
          <span>View details</span>
          <SafeIcon icon={FiArrowRight} className="card-arrow" />
        </div>
      </div>
    </button>
  );
}

export default AppCard;
